import { saveRecord } from '@/entities/shared/record/save-record';
import type { Note } from '../schemas/note';
import { noteSchema } from '../schemas/note';

export async function saveNote(id: string, data: Partial<Note>): Promise<void> {
  await saveRecord('notes', noteSchema, id, data);
}
